import { Platform, useWindowDimensions } from 'react-native'

export type ScreenSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

/**
 * Custom hook to get screen size info and helpers
 */
export const useScreen = (theme?: any) => {
  const { width, height } = useWindowDimensions()

  let screenSize: ScreenSize
  if (width >= 1440) screenSize = 'xl'      // large desktops
  else if (width >= 1024) screenSize = 'lg'  // laptops / small desktops
  else if (width >= 768) screenSize = 'md'   // tablets
  else if (width >= 640) screenSize = 'sm'   // large phones
  else screenSize = 'xs'                     // small phones

  const isMobile = screenSize === 'xs' || screenSize === 'sm'
  const isTablet = screenSize === 'md'
  const isDesktop = screenSize === 'lg' || screenSize === 'xl'
  const isWeb = Platform.OS === 'web'
  const isIos = Platform.OS === 'ios'
  const isAndroid = Platform.OS === 'android'
  const responsivePadding = theme
    ? (() => {
        switch (screenSize) {
          case 'xl':
            return theme.spacing.xxxl * 2
          case 'lg':
            return theme.spacing.xxxl
          case 'md':
            return theme.spacing.lg
          case 'sm':
            return theme.spacing.sm
          case 'xs':
          default:
            return 0
        }
      })()
    : 0

  return {
    width,
    height,
    screenSize,
    isMobile,
    isTablet,
    isDesktop,
    isWeb,
    isIos,
    isAndroid,
    responsivePadding,
  }
}
